//
// Alternatives
//
// Handles rendering and loading of the alternatives panel.
// This includes the alternatives carousel.
// ---------------------------------------------------------------------------

'use strict';

import ImagesLoaded from 'imagesloaded';
import AlternativesCarousel from './alternatives-carousel';

ImagesLoaded.makeJQueryPlugin( $ );

const STATE_LOADING = 'loading';
const STATE_LOADED = 'loaded';

const config = {
    row: '.js-alternatives',
    container: '.js-alternatives__body',
    close: '.js-close',
    carousel: '.c-alt-parts-carousel',
    info: '.js-alt-parts-info',
    loadingClass: 'is-busy',
    hiddenClass: 'is-hidden'
};

export default class Alternatives {
    /**
     * Initalize the alternatives click handlers
     *
     * @param {jQuery} selector
     */
    constructor(selector) {
        this.trigger = selector;
        this.loading = this.trigger.next();
        this.row = this.trigger.closest(config.row);
        this.cells = this.row.children('td');
        this.container = this.row.find(config.container);

        // Setup click events
        selector.on('click', (e) => this.load(e));
        $(window).resize(() => {
            this.recalculateHeights();
        });
    }

    /**
     * Load the alternative parts and render the response
     *
     * @param {object} e - the event
     */
    load (e) {
        e.preventDefault();

        // Reset the click handler so it cannot be clicked again but also
        // doesn't do its normal behaviour
        this.trigger.off('click').on('click', function(e) {
            e.preventDefault();
        });

        this.changeState(STATE_LOADING);

        $.ajax({
            url: this.trigger.data('url'),
            method: 'GET',
            dataType: 'html'
        })
        .done((response, textStatus, jqXHR) => this.render(response, jqXHR))
        .fail(() => this.changeState());
    }

    /**
     * Changes the state of the alternatives
     *
     * @param {string} state
     */
    changeState(state = null) {
        switch (state) {
            case STATE_LOADING:
                this.trigger.addClass(config.hiddenClass);
                this.loading.removeClass(config.hiddenClass);
                break;
            case STATE_LOADED:
                this.loading.addClass(config.hiddenClass);
                break;
            default:
                this.trigger.removeClass(config.hiddenClass);
                this.loading.addClass(config.hiddenClass);
            break;
        }
    }

    /**
     * Render the alternative parts
     *
     * @param {string} response
     * @param {object} jqXHR
     */
    render(response, jqXHR) {
        this.alternatives = $(response);

        let carousel = this.alternatives.find(config.carousel);
        this.container.append(this.alternatives);

        // Create a new carousel
        this.wallop = new AlternativesCarousel(
            carousel[0],
            {
                itemOffset: parseInt(jqXHR.getResponseHeader('X-Item-Offset'), 10) + 1,
                itemCount: parseInt(jqXHR.getResponseHeader('X-Item-Count'), 10),
                itemThisCount:
                    parseInt(jqXHR.getResponseHeader('X-Item-Offset'), 10) +
                    parseInt(jqXHR.getResponseHeader('X-Item-This-Count'), 10)
            }
        );

        this.changeState(STATE_LOADED);

        this.alternatives.imagesLoaded(() => {
            this.recalculateHeights()
        });

        // Attach the counter
        this.wallop.on('change', (e) => this.handleChange(e));
        this.alternatives.find(config.close)
            .on('click', (e) => this.handleClose(e));

        // If there is only 3 or less alternatives we do not want to show 'next' arrow button
        if (this.wallop.isLastSlide()) {
            $(this.wallop.buttonNext).addClass('is-invisible');
        }
    }

    /**
     * Recalculates the height of the row to accommodate the alternatives
     * carousel. This is also called on window resize to handle a resized
     * browser
     *
     * Also calculate the height of the cards so they are all the same height
     */
    recalculateHeights() {
        if (this.alternatives === undefined) {
            return;
        }

        let maxCardHeight = -1;
        let rowHeight = this.alternatives.outerHeight() + 20;
        let cards = this.alternatives.find('.c-alt-parts-carousel__row--current .c-alt-part');

        cards.removeAttr('style');

        cards.each(function() {
            let card = $(this).outerHeight();
            maxCardHeight = maxCardHeight > card ? maxCardHeight : card;
        });

        cards.css('min-height', maxCardHeight + 'px');
        this.cells.css('padding-bottom', rowHeight + 'px');
        this.container.css('height', rowHeight + 'px');
    }

    /**
     * Updates the page counter at the top to reflect the currently viewed
     * alternative parts
     */
    handleChange() {
        let info = this.alternatives.find(config.info);

        info.text(
            info.data('text')
                .replace('{0}', (this.wallop.currentItemIndex * 3) + 1)
                .replace('{1}', (this.wallop.currentItemIndex + 1) * 3)
                .replace('{2}', this.wallop.itemCount)
        );

        // if on last slide
        if (this.wallop.isLastSlide()) {
            info.text(
                info.data('text')
                    .replace('{0}', (this.wallop.currentItemIndex * 3) + 1)
                    .replace('{1}', this.wallop.itemCount)
                    .replace('{2}', this.wallop.itemCount)
            );
        }

        this.alternatives.imagesLoaded(() => {
            this.recalculateHeights()
        });
    }

    /**
     * Reset the row to it's initial state when the close button is clicked
     * Reinitialize the load click handler on the trigger
     *
     * @param {object} e - the event
     */
    handleClose(e) {
        e.preventDefault();

        this.trigger.off('click').on('click', (e) => this.load(e));
        this.trigger.removeClass(config.hiddenClass);

        // Reset the row
        this.container.removeAttr('style');
        this.container.empty();
        this.cells.removeAttr("style");
    }
}

/**
 * Loop over each and every action and attach the Alternatives object to this.
 */
$('.js-alternatives__action').each(function() {
    new Alternatives($(this));
});



// WEBPACK FOOTER //
// ./src/js/components/alternatives.js